/**
 * Reception (web_qa_*) card chrome — defined once.
 *
 * The card components apply these instead of hand-rolling a
 * `<section py-N px-N>` + `rounded-2xl border p-N` wrapper each. A
 * padding/border/background tweak happens *here*, not card-by-card.
 * (Where a card goes and how big it is is `x/y/w/h` in
 * `klyde_web_content/data/web_reception.py`'s ContainerPlacements —
 * the grid cell; this is just the box that fills it.)
 *
 * @layer presentation
 * @arch_domain canvas
 */

export const QA_SECTION = 'web-surface relative py-3 px-3 bg-background text-foreground';
export const QA_BOX = 'rounded-2xl border border-border bg-card/50 p-5 flex flex-col gap-3';
